export default __webpack_public_path__ + "static/media/crane.ba027f74.svg";